import { render, staticRenderFns } from "./NewCustomerAdminModal.vue?vue&type=template&id=43155bdb&scoped=true"
import script from "./NewCustomerAdminModal.vue?vue&type=script&lang=ts"
export * from "./NewCustomerAdminModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43155bdb",
  null
  
)

export default component.exports